import { PropagateLoader } from "react-spinners";

const LoadingSpinner = () => {
  return (
    <div className="flex justify-center items-center h-screen">
      <PropagateLoader color="#00ADEF" size={20} />
    </div>
  );
};

export default LoadingSpinner;
